module.exports = require("@zxing/library");